import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { PreloginService } from '@core/prelogin/services/prelogin.service';
import { AuthenticationService } from '@core/startup';
import { LoginType, RequestType } from '@core/common/constants.service';
import { MessageService } from '@core/shared/services/message.service';
import { TranslateService } from '@ngx-translate/core';
import { SystemSettings } from '@core/models'

@Component({
    selector: 'app-activate-user',
    templateUrl: './activate-user.component.html'
})
export class ActivateUserComponent implements OnInit {
    public formActivationCheck: FormGroup;
    public referenceID: any;
    public isOTPEnabled: boolean=false;
    public timerFlag:boolean=false;
    public isResendOTP: boolean=false
    public loginType: any=LoginType.loginTypes; 
    public label: string ='ParticipantActivation.Username' ;
    public validationError: string='ParticipantActivation.UsernameRequired';
    public BandhanUserApprovalError: string = 'ParticipantActivation.BandhanUserApprovalError'
    public passwordLable: string='ParticipantActivation.ActivationCode'
    public passwordErrorMessage: string='ParticipantActivation.ActivationCodeRequired';
    public expiryTime: string;
    public userName: string;
    public email: string;
    isSubmitted: boolean;
    @Output() showCompleteProfile = new EventEmitter();

    constructor(public formBuilder: FormBuilder, public PreloginService: PreloginService,public authenticationService: AuthenticationService
        ,private messageService: MessageService,public translate: TranslateService,public systemSettings: SystemSettings) { }

    ngOnInit() {
        this.formActivationCheck = this.formBuilder.group({
            username: [null, [Validators.required]],
            email: [null, [Validators.required]],
            activationCode: [null, [Validators.required]],
            login: ['username'],
            otp:   [''],
        });
    }

    validate(formActivationCheck) {       
        this.isSubmitted = true;
        if(formActivationCheck.value.username !== "" && formActivationCheck.value.username !== null 
            && formActivationCheck.value.activationCode !== "" && formActivationCheck.value.activationCode !== null) {
            this.PreloginService.isBandhanUserApproved(formActivationCheck.value.login, formActivationCheck.controls['username'].value).subscribe((res) => {
            if(res){
                    let userName_Value = formActivationCheck.value.username;
            if(this.isOTPEnabled === true){
                userName_Value = this.userName;
            }

            let loginType = '';
            if(this.formActivationCheck.value.login===LoginType.mobile){
                loginType = 'Mobile';
            }else if(this.formActivationCheck.value.login===LoginType.email){
                loginType = 'Email';
            }else{
                loginType = '';
            }
            let rawActivation = this.formActivationCheck.getRawValue();
                this.PreloginService.getUserProgramName(rawActivation.username, window.location.host,loginType ).subscribe((res: any) => {
                if (res.participantProgramDetails.isAccessible) {
                    if (this.isOTPEnabled === false && loginType == 'Mobile') {
                        this.PreloginService.validate(res.participantProgramDetails.username, rawActivation.activationCode, 'username').subscribe(result => {
                    result.activationCode = formActivationCheck.value.activationCode;
                    result.type = formActivationCheck.value.login;
                    this.showCompleteProfile.emit(result);
                }, error => {

                });
                    }
                   else if (this.isOTPEnabled === false && loginType != "Mobile") {
                        this.PreloginService.validate(rawActivation.username, rawActivation.activationCode, rawActivation.login.toString()).subscribe(result => {
                            result.activationCode = formActivationCheck.value.activationCode;
                            result.type = formActivationCheck.value.login;
                            this.showCompleteProfile.emit(result);
                        }, error => {

                        });
                    }
                   else if (this.isOTPEnabled === true && loginType != "Mobile" ) {
                this.PreloginService.validateOTP(this.userName, rawActivation.activationCode, this.referenceID, this.email).subscribe(result => {
                    result.user.activationCode = result.activationCode;
                    result.user.type = formActivationCheck.value.login;
                    this.showCompleteProfile.emit(result.user);
                }, error => {
                    
                });
                    }
                    else if (this.isOTPEnabled === true && loginType == "Mobile") {
                        this.PreloginService.validateOTP(res.participantProgramDetails.username, rawActivation.activationCode, this.referenceID, this.email).subscribe(result => {
                            result.user.activationCode = result.activationCode;
                            result.user.type = formActivationCheck.value.login;
                            this.showCompleteProfile.emit(result.user);
                        }, error => {

                        });
                    }
                } else {
                    this.messageService.showError(this.translate.instant('CustomProgram.LoginProgramValidation'));
                }
            });
                } else {
                    this.messageService.showError(this.translate.instant(this.BandhanUserApprovalError));
                }
            })
        }
    }
    useOTPasPassword(event)
    {
        if(this.formActivationCheck.value.username===null || this.formActivationCheck.value.username === '')
        {
            event.target.checked=false;
            this.messageService.showWarning(this.translate.instant(this.validationError)); 
        }
        else if(event.target.checked){
            this.isOTPEnabled=true;
            this.timerFlag=true;
            this.formActivationCheck.get('activationCode').setValue("");
            this.sendOTP();
            this.passwordLable='ParticipantActivation.OTP'
            this.passwordErrorMessage='ParticipantActivation.OTPRequired'
        }
        else{
            this.isOTPEnabled=false;
            this.timerFlag=false;
            this.expiryTime = null;
            this.passwordLable='ParticipantActivation.ActivationCode';
            this.passwordErrorMessage = 'ParticipantActivation.ActivationCodeRequired';
            this.formActivationCheck.controls['username'].enable();
        }
    }
    sendOTP()
    {
        // debugger;
      
        let rawActivationDetails = this.formActivationCheck.getRawValue();
        this.PreloginService.getUserProgramName(rawActivationDetails.username, window.location.host, rawActivationDetails.login).subscribe((res: any) => {
            if (res.participantProgramDetails.isAccessible) {
                if (rawActivationDetails.login == "mobile") {
                    this.authenticationService.getUserAccount(res.participantProgramDetails.username, 'username', 'Activation').subscribe(reponse => {
                        this.isOTPEnabled = true;
                        this.userName = rawActivationDetails.username;
                        this.email = reponse.emailAddress;
                        this.authenticationService.sendOTP(RequestType.CS_Activation, reponse.id,reponse.emailAddress).subscribe(response => {
                            this.referenceID = response.referenceID;
                            this.expiryTime = response.expiryTime;
                            this.isResendOTP = true;
                            this.formActivationCheck.controls['username'].disable();
                            this.messageService.showSuccess(this.translate.instant('ParticipantLogin.OTPSentSuccessfully'));

                        },
                            error => {
                                this.timerFlag = false;
                            });
                    }, error => {
                        this.timerFlag = false;
                    });
                }
                else if (rawActivationDetails.login != "mobile") {
                    this.authenticationService.getUserAccount(rawActivationDetails.username, rawActivationDetails.login, 'Activation').subscribe(reponse => {
                        this.isOTPEnabled = true;
                        this.userName = reponse.username;
                        this.authenticationService.sendOTP(RequestType.CS_Activation, reponse.id, reponse.emailAddress).subscribe(response => {
                            this.referenceID = response.referenceID;
                            this.expiryTime = response.expiryTime;
                            this.isResendOTP = true;
                            this.timerFlag = true;
                            this.formActivationCheck.controls['username'].disable();
                            this.messageService.showSuccess(this.translate.instant('ParticipantLogin.OTPSentSuccessfully'));
                        },
                            error => {
                                this.timerFlag = false;
                            });
                    }, error => {
                        this.timerFlag = false;
                    });
                }
            }
        });
    }
    changeLable()
    {
        this.label =  this.formActivationCheck.value.login===LoginType.mobile ? 'ParticipantActivation.Mobile'
                    :(this.formActivationCheck.value.login===LoginType.email ? 'ParticipantActivation.Email'
                    :(this.formActivationCheck.value.login===LoginType.username ? 'ParticipantActivation.Username':''));
       this.validationError =  this.formActivationCheck.value.login===LoginType.mobile ? 'ParticipantLogin.MobileNoRequired'
                               :(this.formActivationCheck.value.login===LoginType.email ? 'ParticipantLogin.EmailIdRequired'
                               :(this.formActivationCheck.value.login===LoginType.username ? 'ParticipantLogin.UsernameRequired':''));

        this.formActivationCheck.get('otp').setValue(false);
        this.formActivationCheck.controls['username'].enable();
        this.passwordLable = 'ParticipantActivation.ActivationCode';
        this.isResendOTP = false;
        this.isOTPEnabled = false;
    }

    show: boolean = false;
    password() {
      this.show = !this.show;
    }
 }